import { AppState } from "@shared/interfaces";
import { createSelector } from "reselect";

const selectProject = (state: AppState) => state.project;

export const getProjects = () => createSelector(selectProject, (state) => state.projects);
export const getProjectsTotal = () => createSelector(selectProject, (state) => state.projectsTotal);
export const getFilter = () => createSelector(selectProject, (state) => state.filter);
export const getWorkTypes = () => createSelector(selectProject, (state) => state.workTypes);
